import React, { FC } from 'react'
import { Flex, Text } from '@chakra-ui/react'
import { observer } from 'mobx-react'
import occasionalCustomerStore from '../../../../stores/OccasionalCustomerStore'
import { useTranslation } from 'react-i18next'
import reservationStore from '../../../../stores/ReservationStore'
import { isValidPrice } from '../../../../utils/bookingHelpers'
import Alert from '../../../../components/Alert/Alert'
import css from "../../../reservation/components/Confirmation/Confirmation.module.css";
import {ErrorLevel} from "../../../../stores/ErrorStore";
import userStore from "../../../../stores/UserStore";

const Price: FC<{ children: number; label?: string }> = (props) => {
  const { t } = useTranslation()

  const { children, label = t('price') } = props

  return (
    <>
      <Text mr={3} fontSize="xl">
        {label}:
      </Text>
      <Text fontWeight="bold" fontSize="2xl" color="baseBlue">
        {children.toLocaleString('fi-FI', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}{' '}
        €
      </Text>
    </>
  )
}

const FinalPrice = observer(() => {
  const { currentPrice, prices } = occasionalCustomerStore

  const { booking, hasUnsavedChanges } = reservationStore

  const journeyPrice = booking.cargoJourneys?.[0]?.journeyPrice || 0
  const bookingBalance = booking.bookingBalance || 0

  const { t } = useTranslation()
  const isModifying = Object.hasOwn(booking, 'bookingBalance')
  const canPay = userStore.isPaymentEnabled;

  return (
    <div>
      {hasUnsavedChanges && canPay && (
        <Alert className={css.alert} level={ErrorLevel.warning}>
          {t('unsaved_changes_warning_price')}
        </Alert>
      )}
      <Flex minW="100%" justifyContent="space-between" alignItems="center">
        {isModifying && isValidPrice(journeyPrice) ? (
          <Price>{journeyPrice}</Price>
        ) : isValidPrice(currentPrice) ? (
          <Price>{currentPrice}</Price>
        ) : (
          <Text color="red.400">{t('fill_info_to_see_price')}</Text>
        )}
      </Flex>
      <Flex minW="100%" justifyContent="space-between" alignItems="center">
        {isModifying && isValidPrice(bookingBalance) && (
          <Price label={t('amount_due')}>{bookingBalance}</Price>
        )}
      </Flex>
    </div>
  )
})

export default FinalPrice
